import { GraphySchool } from '@shared-types/graphySchool';
import create, { SetState } from 'zustand';

export interface GraphyHomeStore extends GraphySchoolsTypes { };

export type GraphySchoolsTypes = {
    graphySchools: GraphySchool[],
    setGraphySchools: (graphySchools: GraphySchool[]) => void
};

const graphySchoolsDefaultData = {
    graphySchools: []
};

const graphySchoolsActions = (set: SetState<GraphyHomeStore>) => ({
    setGraphySchools: (graphySchools: GraphySchool[]) =>
        set((state) => {
            const schoolsState = state as GraphySchoolsTypes;
            schoolsState.graphySchools = graphySchools;
        })
})

export const useGraphyHomeStore = create<GraphyHomeStore>(
    (set: SetState<GraphyHomeStore>) => ({
        ...graphySchoolsDefaultData,
        ...graphySchoolsActions(set)
    })
)